var _path, _rect, _rect2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(9 9.5)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13.5,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#E5EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5C13 14.8431 14.3431 13.5 16 13.5H34C35.6569 13.5 37 14.8431 37 16.5V22.5H13V16.5Z",
    fill: "#3178FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.5L19 28.5L21 30.5",
    stroke: "#3178FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 26.5L31 28.5L29 30.5",
    stroke: "#3178FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.632bb0b50756a36bb6d379a1337738de.svg";
export { ForwardRef as ReactComponent };